<template>
  <div>
    <cadastro-base :salvar="salvar">
      <template slot="conteudo">
        <b-row>
          <b-form-group class="col-12 my-0 pb-0">
            <b-form-checkbox
              v-model="form.ativo"
              checked="true"
              class="custom-control-primary"
              style="float:right"
              name="check-button"
              switch
            >
              <label style="font-size: 1rem">Indicação Ativa</label>
            </b-form-checkbox>
          </b-form-group>
        </b-row>
        <b-row>
          <b-form-group
            label="Nome"
            class="col-md-6"
          >
            <validation-provider
              #default="{ errors }"
              rules="required"
              name="Nome"
            >
              <b-form-input
                v-model="form.nome"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-col cols="6">
            <b-form-group label="CPF">
              <masked-input
                ref="cpf"
                v-model="form.cpf"
                :mask="constroiMascaraCpf"
                class="form-control"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="mb-1">
          <b-col>
            <telefone-celular
              :value="form.telefoneContato"
            />
          </b-col>
        </b-row>

        <b-row>
          <b-form-group
            label="E-mail"
            class="col-md-12"
          >

            <validation-provider
              #default="{ errors }"
              rules="email"
              name="E-mail"
            >
              <b-form-input
                v-model="form.email"
                :state="(erroValidacaoEmail !== '') ? false :null"
                @blur="validaEmail"
              />
              <small class="text-danger">{{ errors[0] || erroValidacaoEmail }}</small>
            </validation-provider>
          </b-form-group>
        </b-row>

        <b-row>
          <b-form-group
            label="Observação (opcional)"
            class="col-12"
          >
            <b-textarea v-model="form.observacao" />
          </b-form-group>
        </b-row>
      </template>
    </cadastro-base>
  </div>
</template>

<style lang="scss">
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  opacity: 1;
}
</style>

<script>
import { ValidationProvider } from 'vee-validate'
import {
  required,
} from '@validations'
import CadastroBase from '@/shared/components/cadastro-base/CadastroBase.vue'
import api from '@/app-modulo/comercial/indicacao/shared/services/api'

export default {
  name: 'Indicacao',
  components: {
    CadastroBase,
    ValidationProvider,
    TelefoneCelular: () => import('@/shared/components/telefone-celular/TelefoneCelular.vue'),
  },
  data() {
    return {
      required,
      form: {
        ativo: true,
        nome: '',
        cpf: '',
        telefoneContato: {
          telefoneWhatsApp: false,
          celularWhatsApp: false,
        },
        email: '',
        observacao: '',
      },
      immutableForm: {},
      erroValidacaoEmail: '',
    }
  },
  created() {
    this.state = this.$route.path.indexOf('editar') > 0 ? 'editar' : 'novo'
    if (this.state === 'editar') {
      this.carregar(this.$route.params.id)
    }
  },
  methods: {
    carregar(id) {
      api.getIndicacao(id)
        .then(payload => {
          this.form = payload.data
        })
    },
    salvar() {
      if (!this.erroValidacaoEmail) {
        return new Promise((resolve, reject) => {
          if (this.state === 'novo') {
            api.createIndicacao(this.form)
              .then(() => {
                this.$router.go(-1)
                resolve('Indicação cadastrada com sucesso')
              })
              .catch(err => {
                reject(err)
              })
          } else {
            api.updateIndicacao(this.form.id, this.form)
              .then(() => {
                this.$router.go(-1)
                resolve('Indicação alterada com sucesso')
              })
              .catch(err => {
                reject(err)
              })
          }
        })
      }
      return null
    },
    cancelar() {
      this.$router.go(-1)
    },
    constroiMascaraCpf() {
      return [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]
    },
    validaEmail() {
      if (this.form.email !== '') {
        api.validaEmail(this.form.id, this.form.email)
          .then(payload => {
            if (payload.data) {
              this.erroValidacaoEmail = 'E-mail já existente'
            } else {
              this.erroValidacaoEmail = ''
            }
          })
      }
    },
  },
}
</script>
